import React from 'react'
import * as bs4 from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';
import Navbar from '../Navbar'
import "react-datepicker/dist/react-datepicker.css";
import { ScaleLoader } from 'react-spinners';
import ReactGA from 'react-ga';
import Modal from 'react-modal';
const { proxy } = require('../../ip_api.config')

const customStyles = {
    content: {
        width: '700px',
        height: '200px',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

class Film_CreateCode extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            viewProduct: '',
            dataCodeFocus: [],
            arrItemG1Focus: [],
            arrItemG1Ablemen: [],
            dataCodeAblemen: [],
            dataCodeOther: [],
            arr_save: [],
            arr_check: [],
            item_tamp: [],
            showitem: '',
            modal: false,
            focus_option_itemG3: [],
            focus_option_ibrand2: [],
            focus_option_itemg1: '',
            focus_option_size: '',
            focus_option_ibrand1: '',
            focus_option_detail: '',
            ablemen_option_itemG1: '',
            ablemen_option_itemG3: [],
            ablemen_option_ibrand2: [],
            ablemen_option_sortProduct: '',
            ablemen_option_size: '',
            ablemen_option_rawMat: '',
            ablemen_option_detail: '',
        }
    }

    componentDidMount() {
        ReactGA.initialize('UA-176717650-5');
        ReactGA.pageview('/flim/CreateCode');

        if (localStorage.getItem("ID_User") !== null) {
            this.getOption('Focus/Trade')
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    getOption = async (Product) => {
        console.log('Product', Product)
        this.setState({ isLoading: true })
        if (Product === 'Focus/Trade') {
            let option_itemG3 = await this.get_option_itemG3(Product)
            let option_ibrand2 = await this.get_option_ibrand2(Product)
            let option_itemg1 = await this.get_option_itemG1(Product)
            let option_size = await this.get_option_size(Product)
            let option_ibrand1 = await this.get_option_ibrand1()
            let option_detail = await this.get_option_detail(Product)

            // console.log("get_option_itemG3", option_itemG3)
            this.setState({
                focus_option_itemG3: option_itemG3,
                focus_option_ibrand2: option_ibrand2,
                focus_option_itemg1: option_itemg1,
                focus_option_size: option_size,
                focus_option_ibrand1: option_ibrand1,
                focus_option_detail: option_detail,
                isLoading: false,
            }, () => { this.handleProductType(Product) })
        } else if (Product === 'Ablemen') {
            let option_itemG1 = await this.get_option_itemG1(Product)
            let option_itemG3 = await this.get_option_itemG3(Product)
            let option_ibrand2 = await this.get_option_ibrand2(Product)
            let option_sortProduct = await this.get_option_sortProduct()
            let option_size = await this.get_option_size(Product)
            let option_rawMat = await this.get_option_rawMat()
            let option_detail = await this.get_option_detail(Product)

            this.setState({
                ablemen_option_itemG1: option_itemG1,
                ablemen_option_itemG3: option_itemG3,
                ablemen_option_ibrand2: option_ibrand2,
                ablemen_option_sortProduct: option_sortProduct,
                ablemen_option_size: option_size,
                ablemen_option_rawMat: option_rawMat,
                ablemen_option_detail: option_detail,
                isLoading: false,
            }, () => { this.handleProductType(Product) })
        } else {
            this.setState({
                isLoading: false,
            }, () => { this.handleProductType(Product) })
        }
    }

    get_option_size = async (Product) => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_option_size'
        let arr = []
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({})
        })
            .then(response => response.json())
            .then((responseJson) => {
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        if (Product === 'Focus/Trade') {
                            arr.push(
                                <tr>
                                    <td><bs4.Col><bs4.Input type="radio" name='sizeFocus' value={val.code} style={{ width: 25, height: 25 }} onChange={(e) => this.handleChangeItemFocus(e.target.name, e.target.value)} /></bs4.Col></td>
                                    <td>{val.code}</td>
                                    <td>{val.description}</td>
                                </tr>
                            )
                        } else {
                            arr.push(
                                <tr>
                                    <td><bs4.Col><bs4.Input type="radio" name='sizeAblemen' value={val.code} style={{ width: 25, height: 25 }} onChange={(e) => this.handleChangeItemAblemen(e.target.name, e.target.value)} /></bs4.Col></td>
                                    <td>{val.code}</td>
                                    <td>{val.description}</td>
                                </tr>
                            )
                        }
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    get_option_itemG1 = async (Product) => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_option_itemG1'
        let arr = []
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                type: Product,
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        if (Product === 'Focus/Trade') {
                            arr.push(
                                <tr>
                                    <td><bs4.Col><bs4.Input type="checkbox" name='itemG1Focus' value={val.code} style={{ width: 25, height: 25 }} onChange={(e) => this.handleChangeCheckboxFocus(e.target.checked, e.target.value)} /></bs4.Col></td>
                                    <td>{val.code}</td>
                                    <td>{val.description}</td>
                                </tr>
                            )
                        } else {
                            arr.push(
                                <tr>
                                    <td><bs4.Col><bs4.Input type="checkbox" name='itemG1Ablemen' value={val.code} style={{ width: 25, height: 25 }} onChange={(e) => this.handleChangeCheckboxAblemen(e.target.checked, e.target.value)} /></bs4.Col></td>
                                    <td>{val.code}</td>
                                    <td>{val.description}</td>
                                </tr>
                            )
                        }
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    get_option_ibrand1 = async () => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_option_ibrand1'
        let arr = []
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({})
        })
            .then(response => response.json())
            .then((responseJson) => {
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        if (val.description !== 'ABLEMEN') {
                            arr.push(
                                <tr>
                                    <td><bs4.Col><bs4.Input type="radio" name='ibrand1Focus' value={val.code + '&' + val.description} style={{ width: 25, height: 25 }} onChange={(e) => this.handleChangeItemFocus(e.target.name, e.target.value)} /></bs4.Col></td>
                                    <td>{val.code}</td>
                                    <td>{val.description}</td>
                                </tr>
                            )
                        }
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    get_option_ibrand2 = async (Product) => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_option_ibrand2'
        let arr = []
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                type: Product,
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        arr.push(
                            // <option value={val.code + '&' + val.description}>{val.description}</option>
                            { value: val.code + '&' + val.description, label: val.description }
                        )
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    get_option_itemG3 = async (Product) => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_option_itemG3'
        let arr = []
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                type: Product,
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log('responseJson', responseJson.result)
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        arr.push(
                            // <option value={val.code + '&' + val.description}>{val.description}</option>
                            { value: val.code + '&' + val.description, label: val.description }
                        )
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    get_option_detail = async (Product) => new Promise((resolve, reject) => {
        // console.log('detailProduct', Product)
        let url = proxy.server + '/flim/get_option_detail'
        let arr = []
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({})
        })
            .then(response => response.json())
            .then((responseJson) => {
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        if (Product === 'Focus/Trade') {
                            arr.push(
                                <tr>
                                    <td><bs4.Col><bs4.Input type="radio" name='detailFocus' value={val.code + '&' + val.description} style={{ width: 25, height: 25 }} onChange={(e) => this.handleChangeItemFocus(e.target.name, e.target.value)} /></bs4.Col></td>
                                    <td>{val.code}</td>
                                    <td>{val.description}</td>
                                </tr>
                            )
                        } else {
                            arr.push(
                                <tr>
                                    <td><bs4.Col><bs4.Input type="radio" name='detailAblemen' value={val.code + '&' + val.description} style={{ width: 25, height: 25 }} onChange={(e) => this.handleChangeItemAblemen(e.target.name, e.target.value)} /></bs4.Col></td>
                                    <td>{val.code}</td>
                                    <td>{val.description}</td>
                                </tr>
                            )
                        }
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    get_option_sortProduct = async () => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_option_sortProduct'
        let arr = []
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({})
        })
            .then(response => response.json())
            .then((responseJson) => {
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        arr.push(
                            <tr>
                                <td><bs4.Col><bs4.Input type="radio" name='sortProductAblemen' value={val.code} style={{ width: 25, height: 25 }} onChange={(e) => this.handleChangeItemAblemen(e.target.name, e.target.value)} /></bs4.Col></td>
                                <td>{val.code}</td>
                                <td>{val.description}</td>
                            </tr>
                        )
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    get_option_rawMat = async () => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_option_rawMat'
        let arr = []
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({})
        })
            .then(response => response.json())
            .then((responseJson) => {
                if (responseJson.result.lenght !== 0) {
                    responseJson.result.map(function (val, i) {
                        arr.push(
                            <tr>
                                <td><bs4.Col><bs4.Input type="radio" name='rawMatAblemen' value={val.code} style={{ width: 25, height: 25 }} onChange={(e) => this.handleChangeItemAblemen(e.target.name, e.target.value)} /></bs4.Col></td>
                                <td>{val.code}</td>
                                <td>{val.description}</td>
                            </tr>
                        )
                    }, this)
                    resolve(arr)
                } else {
                    resolve(0)
                }
            })
    })

    handleProductType = (Product) => {
        this.setState({ viewProduct: '' }, () => {
            let view
            if (Product === 'Focus/Trade') {
                view = <div>
                    <bs4.FormGroup row>
                        <bs4.Label style={{ marginLeft: 15, fontSize: '16px' }}>เลือกชนิดย่อยสินค้า</bs4.Label>
                        <bs4.Label style={{ marginLeft: 7, fontSize: '16px', fontWeight: 700 }}>(Digit 5-6)</bs4.Label>
                        <bs4.Col sm='4'>
                            {/* <bs4.Input type="select" name="typeFocus" onChange={(e) => this.handleChangeItemFocus(e.target.name, e.target.value)}>
                                <option value="">------------</option>
                                {this.state.focus_option_itemG3}
                            </bs4.Input> */}

                            <Select className="col-md-12"
                                onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItemFocus('typeFocus', e.value))}
                                options={this.state.focus_option_itemG3}
                                placeholder={'เลือกชนิดย่อยสินค้า'}
                            />
                        </bs4.Col>
                        <bs4.Label style={{ fontSize: '16px' }}>เลือก ibrand2</bs4.Label>
                        <bs4.Label style={{ marginLeft: 7, fontSize: '16px', fontWeight: 700 }}>(Digit 9)</bs4.Label>
                        <bs4.Col sm='4'>
                            {/* <bs4.Input type="select" name="ibrand2Focus" onChange={(e) => this.handleChangeItemFocus(e.target.name, e.target.value)}>
                                <option value="">------------</option>
                                {this.state.focus_option_ibrand2}
                            </bs4.Input> */}

                            <Select className="col-md-12"
                                onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItemFocus('ibrand2Focus', e.value))}
                                options={this.state.focus_option_ibrand2}
                                placeholder={'เลือก ibrand2'}
                            />
                        </bs4.Col>
                    </bs4.FormGroup>
                    <bs4.FormGroup row>
                        <bs4.Col sm='3'>
                            <bs4.Label style={{ fontSize: '16px', marginRight: 20 }}>เลือกกลุ่มสินค้า</bs4.Label>
                            <bs4.Label style={{ fontSize: '16px', fontWeight: 700 }}>(Digit 1-3)</bs4.Label>
                            <bs4.Table bordered style={{ fontSize: 15 }}>
                                <thead style={{ textAlign: 'center' }}>
                                    <tr>
                                        <th width='12%'></th>
                                        <th>Code</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.focus_option_itemg1}
                                </tbody>
                            </bs4.Table>
                        </bs4.Col>
                        <bs4.Col sm='3'>
                            <bs4.Label style={{ fontSize: '16px', marginRight: 20 }}>เลือก Size</bs4.Label>
                            <bs4.Label style={{ fontSize: '16px', fontWeight: 700 }}>(Digit 4)</bs4.Label>
                            <bs4.Label style={{ fontSize: '12px', fontWeight: 700, color: 'red' }}> *เลือกได้เพียง 1 ตัวเลือก</bs4.Label>
                            <bs4.Table bordered style={{ fontSize: 15 }}>
                                <thead style={{ textAlign: 'center' }}>
                                    <tr>
                                        <th width='12%'></th>
                                        <th colSpan='2'>Size</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.focus_option_size}
                                </tbody>
                            </bs4.Table>
                        </bs4.Col>
                        <bs4.Col sm='3'>
                            <bs4.Label style={{ fontSize: '16px', marginRight: 20 }}>เลือก Ibrand1</bs4.Label>
                            <bs4.Label style={{ fontSize: '16px', fontWeight: 700 }}>(Digit 7)</bs4.Label>
                            <bs4.Label style={{ fontSize: '12px', fontWeight: 700, color: 'red' }}> *เลือกได้เพียง 1 ตัวเลือก</bs4.Label>
                            <bs4.Table bordered style={{ fontSize: 15 }}>
                                <thead style={{ textAlign: 'center' }}>
                                    <tr>
                                        <th width='12%'></th>
                                        <th>Code</th>
                                        <th>Ibrand1</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.focus_option_ibrand1}
                                </tbody>
                            </bs4.Table>
                        </bs4.Col>
                        <bs4.Col sm='3'>
                            <bs4.Label style={{ fontSize: '16px', marginRight: 20 }}>เลือก Detail อื่นๆ</bs4.Label>
                            <bs4.Label style={{ fontSize: '16px', fontWeight: 700 }}>(Digit สุดท้าย)</bs4.Label>
                            <bs4.Label style={{ fontSize: '12px', fontWeight: 700, color: 'red' }}> *เลือกได้เพียง 1 ตัวเลือก</bs4.Label>
                            <bs4.Table bordered style={{ fontSize: 15 }}>
                                <thead style={{ textAlign: 'center' }}>
                                    <tr>
                                        <th width='12%'></th>
                                        <th>Code</th>
                                        <th>ชนิดฟิล์ม/สี</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.focus_option_detail}
                                    <tr>
                                        <td><bs4.Col><bs4.Input type="radio" name='detailFocus' value='&' style={{ width: 25, height: 25 }} onChange={(e) => this.handleChangeItemFocus(e.target.name, e.target.value)} /></bs4.Col></td>
                                        <td></td>
                                        <td>None</td>
                                    </tr>
                                </tbody>
                            </bs4.Table>
                        </bs4.Col>
                    </bs4.FormGroup>
                    <bs4.FormGroup row style={{ marginLeft: 30, marginTop: 20, marginBottom: 30 }}>
                        <bs4.Label style={{ fontSize: '16px', fontWeight: 500 }}>Item (ตั้งชื่อ Item)</bs4.Label>
                        <bs4.Col sm='4'>
                            <bs4.Input type="text" name="item_noFocus" onChange={(e) => e.target.value.length > 20 ? alert('ห้ามกรอกเกิน 20 ตัวอักษร') : this.handleChangeItemFocus(e.target.name, e.target.value)} />
                        </bs4.Col>
                        <bs4.Label style={{ fontSize: '16px', fontWeight: 500 }}>Name (ชื่อรุ่นมือถือ)</bs4.Label>
                        <bs4.Col sm='4'>
                            <bs4.Input type="text" name="item_nameFocus" onChange={(e) => e.target.value.length > 60 ? alert('ห้ามกรอกเกิน 60 ตัวอักษร') : this.handleChangeItemFocus(e.target.name, e.target.value)} />
                        </bs4.Col>
                    </bs4.FormGroup>
                    <bs4.FormGroup row style={{ marginLeft: 30, marginTop: 20, marginBottom: 30 }}>
                        <bs4.Label style={{ fontSize: '16px', fontWeight: 500 }}>กว้าง</bs4.Label>
                        <bs4.Col sm='4'>
                            <bs4.Input type="text" name="gross_width" onChange={(e) => this.handleChangeItemFocus(e.target.name, e.target.value)} />
                        </bs4.Col>
                        <bs4.Label style={{ fontSize: '16px', fontWeight: 500 }}>ยาว</bs4.Label>
                        <bs4.Col sm='4'>
                            <bs4.Input type="text" name="gross_height" onChange={(e) => this.handleChangeItemFocus(e.target.name, e.target.value)} />
                        </bs4.Col>
                        <bs4.Button color="warning" style={{ marginLeft: 20, fontWeight: 500 }} onClick={() => this.genCodeFocus()}>GEN CODE</bs4.Button>
                        <bs4.Button color="success" style={{ marginLeft: 20, fontWeight: 500 }} onClick={() => this.modalDB()}>GEN ITEM</bs4.Button>
                    </bs4.FormGroup>
                </div>
            } else if (Product === 'Ablemen') {
                view = <div>
                    <bs4.FormGroup row>
                        <bs4.Col sm='6'>
                            <bs4.Label style={{ fontSize: '16px', marginRight: 20 }}>เลือกกลุ่มสินค้า</bs4.Label>
                            <bs4.Label style={{ fontSize: '16px', fontWeight: 700 }}>(Digit 1-3)</bs4.Label>
                            <bs4.Table bordered style={{ fontSize: 15 }}>
                                <thead style={{ textAlign: 'center' }}>
                                    <tr>
                                        <th width='12%'></th>
                                        <th>Code</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.ablemen_option_itemG1}
                                </tbody>
                            </bs4.Table>
                        </bs4.Col>
                        <bs4.Col sm='6'>
                            <bs4.Label style={{ marginLeft: 10, fontSize: '16px' }}>เลือกชนิดย่อยสินค้า</bs4.Label>
                            <bs4.Label style={{ marginLeft: 7, fontSize: '16px', fontWeight: 700 }}>(Digit 6)</bs4.Label>
                            <bs4.Col sm='12'>
                                {/* <bs4.Input type="select" name="typeAblemen" onChange={(e) => this.handleChangeItemAblemen(e.target.name, e.target.value)}>
                                    <option value="">------</option>
                                    {this.state.ablemen_option_itemG3}
                                </bs4.Input> */}

                                <Select className="col-md-12"
                                    onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItemAblemen('typeAblemen', e.value))}
                                    options={this.state.ablemen_option_itemG3}
                                    placeholder={'เลือกชนิดย่อยสินค้า'}
                                />
                            </bs4.Col>
                            <bs4.Label style={{ marginLeft: 10, fontSize: '16px' }}>เลือก ibrand2</bs4.Label>
                            <bs4.Label style={{ marginLeft: 7, fontSize: '16px', fontWeight: 700 }}>(Digit 9-10)</bs4.Label>
                            <bs4.Col sm='12'>
                                {/* <bs4.Input type="select" name="ibrand2Ablemen" onChange={(e) => this.handleChangeItemAblemen(e.target.name, e.target.value)}>
                                    <option value="">------</option>
                                    {this.state.ablemen_option_ibrand2}
                                </bs4.Input> */}

                                <Select className="col-md-12"
                                    onChange={(e) => this.setState({ selectedOption: e.value }, () => this.handleChangeItemAblemen('ibrand2Ablemen', e.value))}
                                    options={this.state.ablemen_option_ibrand2}
                                    placeholder={'เลือก ibrand2'}
                                />
                            </bs4.Col>
                        </bs4.Col>
                    </bs4.FormGroup>
                    <bs4.FormGroup row>
                        <bs4.Col sm='3'>
                            <bs4.Label style={{ fontSize: '16px', marginRight: 20 }}>เลือกชนิดสินค้า</bs4.Label>
                            <bs4.Label style={{ fontSize: '16px', fontWeight: 700 }}>(Digit 4)</bs4.Label>
                            <bs4.Label style={{ fontSize: '12px', fontWeight: 700, color: 'red' }}> *เลือกได้เพียง 1 ตัวเลือก</bs4.Label>
                            <bs4.Table bordered style={{ fontSize: 15 }}>
                                <thead style={{ textAlign: 'center' }}>
                                    <tr>
                                        <th width='12%'></th>
                                        <th colSpan='2'>Size</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.ablemen_option_sortProduct}
                                </tbody>
                            </bs4.Table>
                        </bs4.Col>
                        <bs4.Col sm='3'>
                            <bs4.Label style={{ fontSize: '16px', marginRight: 20 }}>เลือกขนาดกลุ่มสินค้า</bs4.Label>
                            <bs4.Label style={{ fontSize: '16px', fontWeight: 700 }}>(Digit 5)</bs4.Label>
                            <bs4.Label style={{ fontSize: '12px', fontWeight: 700, color: 'red' }}> *เลือกได้เพียง 1 ตัวเลือก</bs4.Label>
                            <bs4.Table bordered style={{ fontSize: 15 }}>
                                <thead style={{ textAlign: 'center' }}>
                                    <tr>
                                        <th width='12%'></th>
                                        <th colSpan='2'>Size</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.ablemen_option_size}
                                </tbody>
                            </bs4.Table>
                        </bs4.Col>
                        <bs4.Col sm='3'>
                            <bs4.Label style={{ fontSize: '16px', marginRight: 20 }}>เลือก Mat'l&กระบวนการผลิต</bs4.Label>
                            <bs4.Label style={{ fontSize: '16px', fontWeight: 700 }}>(Digit 7)</bs4.Label>
                            <bs4.Label style={{ fontSize: '12px', fontWeight: 700, color: 'red' }}> *เลือกได้เพียง 1 ตัวเลือก</bs4.Label>
                            <bs4.Table bordered style={{ fontSize: 15 }}>
                                <thead style={{ textAlign: 'center' }}>
                                    <tr>
                                        <th width='12%'></th>
                                        <th>Code</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.ablemen_option_rawMat}
                                </tbody>
                            </bs4.Table>
                        </bs4.Col>
                        <bs4.Col sm='3'>
                            <bs4.Label style={{ fontSize: '16px', marginRight: 20 }}>เลือก Detail อื่นๆ</bs4.Label>
                            <bs4.Label style={{ fontSize: '16px', fontWeight: 700 }}>(Digit สุดท้าย)</bs4.Label>
                            <bs4.Label style={{ fontSize: '12px', fontWeight: 700, color: 'red' }}> *เลือกได้เพียง 1 ตัวเลือก</bs4.Label>
                            <bs4.Table bordered style={{ fontSize: 15 }}>
                                <thead style={{ textAlign: 'center' }}>
                                    <tr>
                                        <th width='12%'></th>
                                        <th>Code</th>
                                        <th>ชนิดฟิล์ม/สี</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.ablemen_option_detail}
                                    <tr>
                                        <td><bs4.Col><bs4.Input type="radio" name='detailFocus' value='&' style={{ width: 25, height: 25 }} onChange={(e) => this.handleChangeItemFocus(e.target.name, e.target.value)} /></bs4.Col></td>
                                        <td></td>
                                        <td>None</td>
                                    </tr>
                                </tbody>
                            </bs4.Table>
                        </bs4.Col>
                    </bs4.FormGroup>
                    <bs4.FormGroup row style={{ marginLeft: 30, marginTop: 20, marginBottom: 30 }}>
                        <bs4.Label style={{ fontSize: '16px', fontWeight: 500 }}>Item (ตั้งชื่อ Item)</bs4.Label>
                        <bs4.Col sm='4'>
                            <bs4.Input type="text" name="item_noAblemen" onChange={(e) => e.target.value.length > 20 ? alert('ห้ามกรอกเกิน 20 ตัวอักษร') : this.handleChangeItemAblemen(e.target.name, e.target.value)} />
                        </bs4.Col>
                        <bs4.Label style={{ fontSize: '16px', fontWeight: 500 }}>Name (ชื่อรุ่นมือถือ)</bs4.Label>
                        <bs4.Col sm='4'>
                            <bs4.Input type="text" name="item_nameAblemen" onChange={(e) => e.target.value.length > 60 ? alert('ห้ามกรอกเกิน 60 ตัวอักษร') : this.handleChangeItemAblemen(e.target.name, e.target.value)} />
                        </bs4.Col>
                    </bs4.FormGroup>
                    <bs4.FormGroup row style={{ marginLeft: 30, marginTop: 20, marginBottom: 30 }}>
                        <bs4.Label style={{ fontSize: '16px', fontWeight: 500 }}>กว้าง</bs4.Label>
                        <bs4.Col sm='4'>
                            <bs4.Input type="text" name="gross_width" onChange={(e) => this.handleChangeItemAblemen(e.target.name, e.target.value)} />
                        </bs4.Col>
                        <bs4.Label style={{ fontSize: '16px', fontWeight: 500 }}>ยาว</bs4.Label>
                        <bs4.Col sm='4'>
                            <bs4.Input type="text" name="gross_height" onChange={(e) => this.handleChangeItemAblemen(e.target.name, e.target.value)} />
                        </bs4.Col>
                        <bs4.Button color="warning" style={{ marginLeft: 20, fontWeight: 500 }} onClick={() => this.genCodeAblemen()}>GEN CODE</bs4.Button>
                        <bs4.Button color="success" style={{ marginLeft: 20, fontWeight: 500 }} onClick={() => this.modalDB()}>GEN ITEM</bs4.Button>
                    </bs4.FormGroup>
                </div>
            } else if (Product === 'Other') {
                view = <div>
                    <bs4.FormGroup row style={{ marginLeft: 30, marginTop: 20, marginBottom: 20 }}>
                        <bs4.Label style={{ fontSize: '16px', fontWeight: 500 }}>Item (ตั้งชื่อ Item)</bs4.Label>
                        <bs4.Col sm='4'>
                            <bs4.Input type="text" name="item_noOther" onChange={(e) => e.target.value.length > 20 ? alert('ห้ามกรอกเกิน 20 ตัวอักษร') : this.handleChangeItemOther(e.target.name, e.target.value)} />
                        </bs4.Col>
                        <bs4.Label style={{ fontSize: '16px', fontWeight: 500 }}>Name (ชื่อรุ่นมือถือ)</bs4.Label>
                        <bs4.Col sm='4'>
                            <bs4.Input type="text" name="item_nameOther" onChange={(e) => e.target.value.length > 60 ? alert('ห้ามกรอกเกิน 60 ตัวอักษร') : this.handleChangeItemOther(e.target.name, e.target.value)} />
                        </bs4.Col>
                    </bs4.FormGroup>
                    <bs4.FormGroup row style={{ marginLeft: 30, marginTop: 20, marginBottom: 30 }}>
                        <bs4.Label style={{ fontSize: '16px', fontWeight: 500 }}>กว้าง</bs4.Label>
                        <bs4.Col sm='4'>
                            <bs4.Input type="text" name="gross_width" onChange={(e) => this.handleChangeItemOther(e.target.name, e.target.value)} />
                        </bs4.Col>
                        <bs4.Label style={{ fontSize: '16px', fontWeight: 500 }}>ยาว</bs4.Label>
                        <bs4.Col sm='4'>
                            <bs4.Input type="text" name="gross_height" onChange={(e) => this.handleChangeItemOther(e.target.name, e.target.value)} />
                        </bs4.Col>
                        <bs4.Button color="warning" style={{ marginLeft: 20, fontWeight: 500 }} onClick={() => this.genCodeOther()}>GEN CODE</bs4.Button>
                        <bs4.Button color="success" style={{ marginLeft: 20, fontWeight: 500 }} onClick={() => this.modalDB()}>GEN ITEM</bs4.Button>
                    </bs4.FormGroup>
                </div >
            }

            this.setState({ viewProduct: view })
        })
    }

    onDelete = (i) => {
        this.state.item_tamp.splice(i, 1)
        this.setState({
            item_tamp: this.state.item_tamp,
        }, () => {
            // console.log('item_tamp', this.state.item_tamp)
            this.previewItem()
        })
    }

    get_dataFocusTrade = async (Product, itemG3, ibrand1) => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_dataFocusTrade'
        let arr = []
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                type_product: Product,
                itemG3: itemG3,
                ibrand1: ibrand1
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                if (responseJson.result.lenght !== 0) {
                    resolve(responseJson.result)
                } else {
                    resolve(0)
                }
            })
    })

    handleChangeItemFocus(name, value) {
        const { dataCodeFocus } = this.state
        if (dataCodeFocus.length === 0) {
            let arr = []
            let data
            if (name === 'typeFocus') {
                let arrValue = value.split('&')
                data = {
                    type: arrValue[0],
                    type_des: arrValue[1],
                    ibrand2: '',
                    ibrand2_des: '',
                    size: '',
                    ibrand1: '',
                    ibrand1_des: '',
                    detail: '',
                    detail_des: '',
                    item_no: '',
                    item_name: '',
                    gross_width: '',
                    gross_height: ''
                }
            } else if (name === 'ibrand2Focus') {
                let arrValue = value.split('&')
                data = {
                    type: '',
                    type_des: '',
                    ibrand2: arrValue[0],
                    ibrand2_des: arrValue[1],
                    size: '',
                    ibrand1: '',
                    ibrand1_des: '',
                    detail: '',
                    detail_des: '',
                    item_no: '',
                    item_name: '',
                    gross_width: '',
                    gross_height: ''
                }
            } else if (name === 'sizeFocus') {
                data = {
                    type: '',
                    type_des: '',
                    ibrand2: '',
                    ibrand2_des: '',
                    size: value,
                    ibrand1: '',
                    ibrand1_des: '',
                    detail: '',
                    detail_des: '',
                    item_no: '',
                    item_name: '',
                    gross_width: '',
                    gross_height: ''
                }
            } else if (name === 'ibrand1Focus') {
                let arrValue = value.split('&')
                data = {
                    type: '',
                    type_des: '',
                    ibrand2: '',
                    ibrand2_des: '',
                    size: '',
                    ibrand1: arrValue[0],
                    ibrand1_des: arrValue[1],
                    detail: '',
                    detail_des: '',
                    item_no: '',
                    item_name: '',
                    gross_width: '',
                    gross_height: ''
                }
            } else if (name === 'detailFocus') {
                let arrValue = value.split('&')
                data = {
                    type: '',
                    type_des: '',
                    ibrand2: '',
                    ibrand2_des: '',
                    size: '',
                    ibrand1: '',
                    ibrand1_des: '',
                    detail: arrValue[0],
                    detail_des: arrValue[1],
                    item_no: '',
                    item_name: '',
                    gross_width: '',
                    gross_height: ''
                }
            } else if (name === 'item_noFocus') {
                data = {
                    type: '',
                    type_des: '',
                    ibrand2: '',
                    ibrand2_des: '',
                    size: '',
                    ibrand1: '',
                    ibrand1_des: '',
                    detail_des: '',
                    detail: '',
                    item_no: value,
                    item_name: '',
                    gross_width: '',
                    gross_height: ''
                }
            } else if (name === 'item_nameFocus') {
                data = {
                    type: '',
                    type_des: '',
                    ibrand2: '',
                    ibrand2_des: '',
                    size: '',
                    ibrand1: '',
                    ibrand1_des: '',
                    detail: '',
                    detail_des: '',
                    item_no: '',
                    item_name: value,
                    gross_width: '',
                    gross_height: ''
                }
            } else if (name === 'gross_width') {
                data = {
                    type: '',
                    type_des: '',
                    ibrand2: '',
                    ibrand2_des: '',
                    size: '',
                    ibrand1: '',
                    ibrand1_des: '',
                    detail: '',
                    detail_des: '',
                    item_no: '',
                    item_name: '',
                    gross_width: value,
                    gross_height: ''
                }
            } else if (name === 'gross_height') {
                data = {
                    type: '',
                    type_des: '',
                    ibrand2: '',
                    ibrand2_des: '',
                    size: '',
                    ibrand1: '',
                    ibrand1_des: '',
                    detail: '',
                    detail_des: '',
                    item_no: '',
                    item_name: '',
                    gross_width: '',
                    gross_height: value
                }
            }

            arr.push(data)
            this.setState({ dataCodeFocus: arr })
        } else {
            if (name === 'typeFocus') {
                let arrValue = value.split('&')
                dataCodeFocus[0].type = arrValue[0]
                dataCodeFocus[0].type_des = arrValue[1]
            } else if (name === 'ibrand2Focus') {
                let arrValue = value.split('&')
                dataCodeFocus[0].ibrand2 = arrValue[0]
                dataCodeFocus[0].ibrand2_des = arrValue[1]
            } else if (name === 'sizeFocus') {
                dataCodeFocus[0].size = value
            } else if (name === 'ibrand1Focus') {
                let arrValue = value.split('&')
                dataCodeFocus[0].ibrand1 = arrValue[0]
                dataCodeFocus[0].ibrand1_des = arrValue[1]
            } else if (name === 'detailFocus') {
                let arrValue = value.split('&')
                dataCodeFocus[0].detail = arrValue[0]
                dataCodeFocus[0].detail_des = arrValue[1]
            } else if (name === 'item_noFocus') {
                dataCodeFocus[0].item_no = value
            } else if (name === 'item_nameFocus') {
                dataCodeFocus[0].item_name = value
            } else if (name === 'gross_width') {
                dataCodeFocus[0].gross_width = value
            } else if (name === 'gross_height') {
                dataCodeFocus[0].gross_height = value
            }
            this.setState({ dataCodeFocus: this.state.dataCodeFocus })
        }
    }

    handleChangeCheckboxFocus = (check, value) => {
        const { arrItemG1Focus } = this.state
        if (check === true) {
            let arr = []
            let data = {
                itemG1: value,
            }

            arr.push(data)
            let temp = arrItemG1Focus.concat(arr)
            this.setState({ arrItemG1Focus: temp })
        } else {
            for (var i = 0; i < arrItemG1Focus.length; i++) {
                if (arrItemG1Focus[i].itemG1 === value) {
                    arrItemG1Focus.splice(i, 1);
                }
            }
            this.setState({ arrItemG1Focus: this.state.arrItemG1Focus })
        }
    }

    genCodeFocus = async () => {

        const { arrItemG1Focus, dataCodeFocus } = this.state
        let arr = []

        if (arrItemG1Focus.length === 0 ||
            dataCodeFocus.length === 0 ||
            dataCodeFocus[0].size === '' ||
            dataCodeFocus[0].type === '' ||
            dataCodeFocus[0].ibrand1 === '' ||
            dataCodeFocus[0].ibrand2 === '' ||
            dataCodeFocus[0].item_no === '' ||
            dataCodeFocus[0].ibrand1_des === '' ||
            dataCodeFocus[0].type_des === '' ||
            dataCodeFocus[0].ibrand2_des === '' ||
            dataCodeFocus[0].item_name === '') {
            alert('ข้อมูลไม่ครบ')
        } else {
            let FocusTrade = await this.get_dataFocusTrade('Focus/Trade', dataCodeFocus[0].type_des, dataCodeFocus[0].ibrand1_des)
            console.log('dataFocusTrade', FocusTrade[0])
            let FocusTrade_code
            let FocusTrade_description

            if (FocusTrade[0] === null || FocusTrade[0] === undefined) {
                FocusTrade_code = ' '
                FocusTrade_description = ' '
            } else {
                FocusTrade_code = FocusTrade[0].code
                FocusTrade_description = FocusTrade[0].description
            }

            arrItemG1Focus.map(function (val, i) {
                let detail = dataCodeFocus[0].detail === '' ? '' : '-' + dataCodeFocus[0].detail
                let pretype = val.itemG1.charAt(0) === 'S' ? 'SM'
                    : val.itemG1.substr(0, 3) === 'TAB' ? 'AB'
                        : val.itemG1.substr(0, 3) === 'T0A' ? 'RM' : ''
                let _name = val.itemG1 + dataCodeFocus[0].size
                    + FocusTrade_code
                    + dataCodeFocus[0].ibrand1
                    + '-'
                    + dataCodeFocus[0].ibrand2
                    + dataCodeFocus[0].item_no
                    + detail

                let description = pretype
                    + ' '
                    + dataCodeFocus[0].ibrand1_des
                    + ' '
                    + FocusTrade_description
                    + ' '
                    + dataCodeFocus[0].ibrand2_des
                    + ' '
                    + dataCodeFocus[0].item_name
                    + ' '
                    + dataCodeFocus[0].detail_des

                let data = {
                    name: _name,
                    description: description.charAt(0) === ' ' ? description.substr(1) : description,
                    gross_width: val.itemG1.charAt(0) === 'G' ? '' : val.itemG1.charAt(0) === 'P' ? '' : val.itemG1.charAt(0) === 'U' ? '' : dataCodeFocus[0].gross_width,
                    gross_height: val.itemG1.charAt(0) === 'G' ? '' : val.itemG1.charAt(0) === 'P' ? '' : val.itemG1.charAt(0) === 'U' ? '' : dataCodeFocus[0].gross_height,
                    line_discount_group: '',
                    itemG4: '',
                    ibrand1: dataCodeFocus[0].ibrand1_des,
                    ibrand2: dataCodeFocus[0].ibrand2_des,
                    ibrand3: '',
                    ibrand3_des: '',
                    ibrand4_code: '',
                    type: 'Focus',
                    itemG3: dataCodeFocus[0].type_des
                }

                arr.push(data)
            })

            let temp = this.state.item_tamp.concat(arr)

            this.setState({ item_tamp: temp }, () => { this.previewItem() })
        }

    }

    handleChangeItemAblemen(name, value) {
        const { dataCodeAblemen } = this.state
        if (dataCodeAblemen.length === 0) {
            let arr = []
            let data
            if (name === 'typeAblemen') {
                let arrValue = value.split('&')
                data = {
                    type: arrValue[0],
                    type_des: arrValue[1],
                    ibrand2: '',
                    ibrand2_des: '',
                    sortProduct: '',
                    size: '',
                    rawMat: '',
                    detail: '',
                    detail_des: '',
                    item_no: '',
                    item_name: '',
                    gross_width: '',
                    gross_height: ''
                }
            } else if (name === 'ibrand2Ablemen') {
                let arrValue = value.split('&')
                data = {
                    type: '',
                    type_des: '',
                    ibrand2: arrValue[0],
                    ibrand2_des: arrValue[1],
                    sortProduct: '',
                    size: '',
                    rawMat: '',
                    detail: '',
                    detail_des: '',
                    item_no: '',
                    item_name: '',
                    gross_width: '',
                    gross_height: ''
                }
            } else if (name === 'sortProductAblemen') {
                data = {
                    type: '',
                    type_des: '',
                    ibrand2: '',
                    ibrand2_des: '',
                    sortProduct: value,
                    size: '',
                    rawMat: '',
                    detail: '',
                    detail_des: '',
                    item_no: '',
                    item_name: '',
                    gross_width: '',
                    gross_height: ''
                }
            } else if (name === 'sizeAblemen') {
                data = {
                    type: '',
                    type_des: '',
                    ibrand2: '',
                    ibrand2_des: '',
                    sortProduct: '',
                    size: value,
                    rawMat: '',
                    detail: '',
                    detail_des: '',
                    item_no: '',
                    item_name: '',
                    gross_width: '',
                    gross_height: ''
                }
            } else if (name === 'rawMatAblemen') {
                data = {
                    type: '',
                    type_des: '',
                    ibrand2: '',
                    ibrand2_des: '',
                    sortProduct: '',
                    size: '',
                    rawMat: value,
                    detail: '',
                    detail_des: '',
                    item_no: '',
                    item_name: '',
                    gross_width: '',
                    gross_height: ''
                }
            } else if (name === 'detailAblemen') {
                let arrValue = value.split('&')
                data = {
                    type: '',
                    type_des: '',
                    ibrand2: '',
                    ibrand2_des: '',
                    sortProduct: '',
                    size: '',
                    rawMat: '',
                    detail: arrValue[0],
                    detail_des: arrValue[1],
                    item_no: '',
                    item_name: '',
                    gross_width: '',
                    gross_height: ''
                }
            } else if (name === 'item_noAblemen') {
                data = {
                    type: '',
                    type_des: '',
                    ibrand2: '',
                    ibrand2_des: '',
                    sortProduct: '',
                    size: '',
                    rawMat: '',
                    detail: '',
                    detail_des: '',
                    item_no: value,
                    item_name: '',
                    gross_width: '',
                    gross_height: ''
                }
            } else if (name === 'item_nameAblemen') {
                data = {
                    type: '',
                    type_des: '',
                    ibrand2: '',
                    ibrand2_des: '',
                    sortProduct: '',
                    size: '',
                    rawMat: '',
                    detail: '',
                    detail_des: '',
                    item_no: '',
                    item_name: value,
                    gross_width: '',
                    gross_height: ''
                }
            } else if (name === 'gross_width') {
                data = {
                    type: '',
                    type_des: '',
                    ibrand2: '',
                    ibrand2_des: '',
                    sortProduct: '',
                    size: '',
                    rawMat: '',
                    detail: '',
                    detail_des: '',
                    item_no: '',
                    item_name: '',
                    gross_width: value,
                    gross_height: ''
                }
            } else if (name === 'gross_height') {
                data = {
                    type: '',
                    type_des: '',
                    ibrand2: '',
                    ibrand2_des: '',
                    sortProduct: '',
                    size: '',
                    rawMat: '',
                    detail: '',
                    detail_des: '',
                    item_no: '',
                    item_name: '',
                    gross_width: '',
                    gross_height: value
                }
            }

            arr.push(data)
            this.setState({ dataCodeAblemen: arr })
        } else {
            if (name === 'typeAblemen') {
                let arrValue = value.split('&')
                dataCodeAblemen[0].type = arrValue[0]
                dataCodeAblemen[0].type_des = arrValue[1]
            } else if (name === 'ibrand2Ablemen') {
                let arrValue = value.split('&')
                dataCodeAblemen[0].ibrand2 = arrValue[0]
                dataCodeAblemen[0].ibrand2_des = arrValue[1]
            } else if (name === 'sortProductAblemen') {
                dataCodeAblemen[0].sortProduct = value
            } else if (name === 'sizeAblemen') {
                dataCodeAblemen[0].size = value
            } else if (name === 'rawMatAblemen') {
                dataCodeAblemen[0].rawMat = value
            } else if (name === 'detailAblemen') {
                let arrValue = value.split('&')
                dataCodeAblemen[0].detail = arrValue[0]
                dataCodeAblemen[0].detail_des = arrValue[1]
            } else if (name === 'item_noAblemen') {
                dataCodeAblemen[0].item_no = value
            } else if (name === 'item_nameAblemen') {
                dataCodeAblemen[0].item_name = value
            } else if (name === 'gross_width') {
                dataCodeAblemen[0].gross_width = value
            } else if (name === 'gross_height') {
                dataCodeAblemen[0].gross_height = value
            }
            this.setState({ dataCodeAblemen: this.state.dataCodeAblemen })
        }
    }

    handleChangeCheckboxAblemen = (check, value) => {
        const { arrItemG1Ablemen } = this.state
        if (check === true) {
            let arr = []
            let data = {
                itemG1: value,
            }

            arr.push(data)
            let temp = arrItemG1Ablemen.concat(arr)
            this.setState({ arrItemG1Ablemen: temp })
        } else {
            for (var i = 0; i < arrItemG1Ablemen.length; i++) {
                if (arrItemG1Ablemen[i].itemG1 === value) {
                    arrItemG1Ablemen.splice(i, 1);
                }
            }
            this.setState({ arrItemG1Ablemen: this.state.arrItemG1Ablemen })
        }
    }

    genCodeAblemen = async () => {
        const { arrItemG1Ablemen, dataCodeAblemen } = this.state
        let arr = []

        // console.log('dataCodeAblemen', dataCodeAblemen)

        if (arrItemG1Ablemen.length === 0 ||
            dataCodeAblemen.length === 0 ||
            dataCodeAblemen[0].sortProduct === '' ||
            dataCodeAblemen[0].size === '' ||
            dataCodeAblemen[0].type === '' ||
            dataCodeAblemen[0].rawMat === '' ||
            dataCodeAblemen[0].ibrand2 === '' ||
            dataCodeAblemen[0].item_no === '' ||
            dataCodeAblemen[0].type_des === '' ||
            dataCodeAblemen[0].ibrand2_des === '' ||
            dataCodeAblemen[0].item_name === '') {
            alert('ข้อมูลไม่ครบ')
        } else {
            let AblemenFocusTrade = await this.get_dataFocusTrade('Ablemen', dataCodeAblemen[0].type_des, 'Ablemen')
            console.log('dataFocusTrade', AblemenFocusTrade[0])
            let Ablemen_description

            if (AblemenFocusTrade[0] === null || AblemenFocusTrade[0] === undefined) {
                Ablemen_description = ' '
            } else {
                Ablemen_description = AblemenFocusTrade[0].description
            }

            arrItemG1Ablemen.map(function (val, i) {
                let pretype = val.itemG1.charAt(0) === 'S' ? 'SM'
                    : val.itemG1.substr(0, 3) === 'TAB' ? 'AB'
                        : val.itemG1.substr(0, 3) === 'T0A' ? 'RM' : ''

                let _name = val.itemG1
                    + dataCodeAblemen[0].sortProduct
                    + dataCodeAblemen[0].size
                    + dataCodeAblemen[0].type
                    + dataCodeAblemen[0].rawMat
                    + '-'
                    + dataCodeAblemen[0].ibrand2
                    + dataCodeAblemen[0].item_no
                    + dataCodeAblemen[0].detail

                let description = pretype
                    + ' '
                    + 'Ablemen'
                    + ' '
                    + Ablemen_description
                    + ' '
                    + dataCodeAblemen[0].ibrand2_des
                    + ' '
                    + dataCodeAblemen[0].item_name
                    + ' '
                    + dataCodeAblemen[0].detail_des

                let data = {
                    name: _name,
                    description: description.charAt(0) === ' ' ? description.substr(1) : description,
                    gross_width: val.itemG1.charAt(0) === 'G' ? '' : val.itemG1.charAt(0) === 'P' ? '' : val.itemG1.charAt(0) === 'U' ? '' : dataCodeAblemen[0].gross_width,
                    gross_height: val.itemG1.charAt(0) === 'G' ? '' : val.itemG1.charAt(0) === 'P' ? '' : val.itemG1.charAt(0) === 'U' ? '' : dataCodeAblemen[0].gross_height,
                    line_discount_group: '',
                    itemG4: '',
                    ibrand1: 'ABLEMEN',
                    ibrand2: dataCodeAblemen[0].ibrand2_des,
                    ibrand3: '',
                    ibrand3_des: '',
                    ibrand4_code: '',
                    type: 'Ablemen',
                    itemG3: dataCodeAblemen[0].type_des
                }

                arr.push(data)
            })

            let temp = this.state.item_tamp.concat(arr)

            this.setState({ item_tamp: temp }, () => { this.previewItem() })
        }
    }

    handleChangeItemOther(name, value) {
        const { dataCodeOther } = this.state
        if (dataCodeOther.length === 0) {
            let arr = []
            let data
            if (name === 'item_noOther') {
                data = {
                    item_no: value,
                    item_name: ''
                }
            } else if (name === 'item_nameOther') {
                data = {
                    item_no: '',
                    item_name: value
                }
            } else if (name === 'gross_width') {
                data = {
                    item_no: '',
                    item_name: '',
                    gross_width: value,
                    gross_height: ''
                }
            } else if (name === 'gross_height') {
                data = {
                    item_no: '',
                    item_name: '',
                    gross_width: '',
                    gross_height: value
                }
            }

            arr.push(data)
            this.setState({ dataCodeOther: arr })
        } else {
            if (name === 'item_noOther') {
                dataCodeOther[0].item_no = value
            } else if (name === 'item_nameOther') {
                dataCodeOther[0].item_name = value
            } else if (name === 'gross_width') {
                dataCodeOther[0].gross_width = value
            } else if (name === 'gross_height') {
                dataCodeOther[0].gross_height = value
            }

            this.setState({ dataCodeOther: this.state.dataCodeOther })
        }
    }

    genCodeOther = () => {
        const { dataCodeOther } = this.state
        let arr = []

        if (dataCodeOther.length === 0 ||
            dataCodeOther[0].item_no === '' ||
            dataCodeOther[0].item_name === '') {
            alert('ข้อมูลไม่ครบ')
        } else {
            let _name = dataCodeOther[0].item_no

            let description = dataCodeOther[0].item_name

            let data = {
                name: _name,
                description: description,
                gross_width: dataCodeOther[0].gross_width,
                gross_height: dataCodeOther[0].gross_height,
                line_discount_group: '',
                itemG4: '',
                ibrand1: '',
                ibrand2: '',
                ibrand3: '',
                ibrand3_des: '',
                ibrand4_code: '',
                type: 'Other',
                itemG3: ''
            }

            arr.push(data)
            let temp = this.state.item_tamp.concat(arr)

            this.setState({ item_tamp: temp }, () => { this.previewItem() })
        }
    }

    previewItem = () => {
        const { item_tamp } = this.state
        let arr = []

        item_tamp.map(function (val, i) {
            arr.push(
                <tr style={{ textAlign: 'center' }}>
                    <td style={{ width: 40 }}><bs4.Button size='sm' color='danger' onClick={(e) => this.onDelete(i)}>DEL</bs4.Button></td>
                    {val.name.length > 20
                        ? <td style={{ width: 150, color: 'red', fontWeight: 500 }}>{val.name}</td>
                        : <td style={{ width: 150 }}>{val.name}</td>
                    }
                    {val.description.length > 60
                        ? <td style={{ width: 150, color: 'red', fontWeight: 500 }}>{val.description}</td>
                        : <td style={{ width: 150 }}>{val.description}</td>
                    }
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="gross_width" onChange={(e) => this.onhandleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.gross_width} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="gross_height" onChange={(e) => this.onhandleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.gross_height} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="line_discount_group" onChange={(e) => this.onhandleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.line_discount_group} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="itemG4" onChange={(e) => this.onhandleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.itemG4} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="ibrand3" onChange={(e) => this.onhandleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.ibrand3} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="ibrand3_des" onChange={(e) => this.onhandleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.ibrand3_des} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="ibrand4_code" onChange={(e) => this.onhandleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.ibrand4_code} />
                        </bs4.Col>
                    </td>
                </tr>
            )
        }, this)

        this.setState({ showItem: arr }, () => { console.log('GENCODE') })
    }

    onhandleChangeItem = (index, name, value) => {
        if (index === 'a') {
            if (name === 'gross_width') {
                this.state.item_tamp.map(function (val, i) {
                    val.gross_width = value
                })
            } else if (name === 'gross_height') {
                this.state.item_tamp.map(function (val, i) {
                    val.gross_height = value
                })
            } else if (name === 'line_discount_group') {
                this.state.item_tamp.map(function (val, i) {
                    val.line_discount_group = value
                })
            } else if (name === 'itemG4') {
                this.state.item_tamp.map(function (val, i) {
                    val.itemG4 = value
                })
            } else if (name === 'ibrand3') {
                this.state.item_tamp.map(function (val, i) {
                    val.ibrand3 = value
                })
            } else if (name === 'ibrand3_des') {
                this.state.item_tamp.map(function (val, i) {
                    val.ibrand3_des = value
                })
            } else if (name === 'ibrand4_code') {
                this.state.item_tamp.map(function (val, i) {
                    val.ibrand4_code = value
                })
            }
        } else if (name === 'gross_width') {
            this.state.item_tamp[index].gross_width = value
        } else if (name === 'gross_height') {
            this.state.item_tamp[index].gross_height = value
        } else if (name === 'line_discount_group') {
            this.state.item_tamp[index].line_discount_group = value
        } else if (name === 'itemG4') {
            this.state.item_tamp[index].itemG4 = value
        } else if (name === 'ibrand3') {
            this.state.item_tamp[index].ibrand3 = value
        } else if (name === 'ibrand3_des') {
            this.state.item_tamp[index].ibrand3_des = value
        } else if (name === 'ibrand4_code') {
            this.state.item_tamp[index].ibrand4_code = value
        }

        this.setState({
            item_tamp: this.state.item_tamp
        }, () => {
            // console.log('item_tamp', this.state.item_tamp)
            this.previewItem()
        })
    }

    modalDB = () => {
        if (this.state.item_tamp.length === 0) {
            alert('ไม่มีข้อมูล')
        } else {
            this.setState({
                modal: !this.state.modal
            })
        }
    }

    checkItem = (db, check) => {
        if (check === true) {
            let arr = this.state.arr_check.concat(db)
            this.setState({
                arr_check: arr
            })
        } else {
            let arr = this.state.arr_check

            for (var i = arr.length; i--;) {
                if (arr[i] === db) arr.splice(i, 1);
            }
            this.setState({
                arr_check: arr
            })
        }
    }

    addItemDB = () => {
        const { arr_save, item_tamp, arr_check } = this.state

        let arr = []
        let temp
        item_tamp.map(function (val, i) {

            arr_check.map(function (el, j) {
                let data = {
                    product_type: val.type,
                    dbname: el,
                    name: val.name,
                    description: val.description,
                    gross_width: val.gross_width,
                    gross_height: val.gross_height,
                    line_discount_group: val.line_discount_group,
                    itemG4: val.itemG4,
                    ibrand3: val.ibrand3,
                    ibrand4_code: val.ibrand4_code,
                    buyer_group: '',
                    itemG1: '',
                    itemG2: '',
                    itemG3: val.itemG3,
                    ibrand1: val.ibrand1,
                    ibrand2: val.ibrand2,
                    status_item: '',
                    unit_Collect: '',
                    unit_Buy: '',
                    unit_Sale: '',
                    DefaultOrderType: '',
                    EcoResTrackingDimensionGroup_Name: '',
                    ItemGroupId: '',
                    CostGroupId: '',
                    BatchNumGroupId: '',
                    SerialNumGroupId: '',
                    InventTableModuleInvent_UnitId: '',
                    InventTableModulePurch_UnitId: '',
                    InventTableModulePurch_OverDeliveryPct: '',
                    InventTableModulePurch_UnderDeliveryPct: '',
                    InventTableModuleSales_UnitId: '',
                    ECL_NumberSequenceGroupProd: '',
                    BOMUnitId: '',
                    DefaultDimension: '',
                    PurchInventLocationId: '',
                    ItemInventLocationId: '',
                    SalesInventLocationId: '',
                    image: '',
                    itemG1_des: '',
                    itemG2_des: '',
                    itemG3_des: val.itemG3,
                    itemG4_des: val.itemG4,
                    ibrand1_des: val.ibrand1,
                    ibrand2_des: val.ibrand2,
                    ibrand3_des: val.ibrand3_des,
                    ibrand4_des: val.ibrand4_code,
                    create_user: localStorage.getItem("ID_User"),
                    create_date: new Date()
                }

                arr.push(data)
            }, this)
        }, this)

        temp = arr_save.concat(arr)

        this.setState({
            arr_save: temp
        }, () => {
            // console.log('arr_save', this.state.arr_save)
            this.props.history.push({
                pathname: '/Flim/TempItem',
                state: { arr_item: this.state.arr_save }
            })
        })
    }

    render() {
        return <div>
            <Navbar nav={'Flim'} menu={'Flim_CreateCode'} />
            <bs4.FormGroup style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row>
                    <bs4.Label style={{ marginLeft: 15, fontSize: '18px', fontWeight: 700, marginRight: 20 }}>เลือก Type Product</bs4.Label>
                    <bs4.Col sm='6'>
                        <bs4.Input type='select' onChange={(e) => this.getOption(e.target.value)}>
                            <option value='Focus/Trade'>Focus/Trade</option>
                            <option value='Ablemen'>Ablemen</option>
                            <option value='Other'>Other</option>
                        </bs4.Input>
                    </bs4.Col>
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>

                {this.state.viewProduct}

                <bs4.Table bordered hover style={{ fontSize: 15 }}>
                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th></th>
                            <th style={{ backgroundColor: '#61ba52', color: '#000', width: 200 }}>Code</th>
                            <th style={{ backgroundColor: '#61ba52', color: '#000', width: 320 }}>Name</th>
                            <th style={{ width: 150 }}>Gross Width</th>
                            <th style={{ width: 150 }}>Gross Height</th>
                            <th>Line Discount Group</th>
                            <th>Item G4</th>
                            <th>Ibrand3</th>
                            <th>Ibrand3 Des</th>
                            <th>Ibrand4 Code</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style={{ textAlign: 'center' }}>
                            <td style={{ width: 40 }}></td>
                            <td style={{ width: 150 }}></td>
                            <td style={{ width: 150 }}></td>
                            <td>
                                <bs4.Col sm='12'>
                                    <bs4.Input type="text" name="gross_width" onChange={(e) => this.onhandleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12'>
                                    <bs4.Input type="text" name="gross_height" onChange={(e) => this.onhandleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12'>
                                    <bs4.Input type="text" name="line_discount_group" onChange={(e) => this.onhandleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12'>
                                    <bs4.Input type="text" name="itemG4" onChange={(e) => this.onhandleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12'>
                                    <bs4.Input type="text" name="ibrand3" onChange={(e) => this.onhandleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12'>
                                    <bs4.Input type="text" name="ibrand3_des" onChange={(e) => this.onhandleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12'>
                                    <bs4.Input type="text" name="ibrand4_code" onChange={(e) => this.onhandleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                        </tr>
                        {this.state.showItem}
                    </tbody>
                </bs4.Table>
            </bs4.FormGroup>

            <Modal
                isOpen={this.state.modal}
                onRequestClose={this.modalDB}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <bs4.Button color='link' onClick={this.modalDB} style={{ fontSize: 20, float: 'right' }}>X</bs4.Button>
                <bs4.FormGroup row style={{ marginLeft: 20 }}>
                    <h2>เลือกฐานข้อมูล</h2>
                </bs4.FormGroup>
                <bs4.FormGroup row style={{ marginLeft: 20, marginTop: 20 }}>
                    <bs4.FormGroup check style={{ marginRight: 20 }}>
                        <bs4.Label check>
                            <bs4.Input type="checkbox" style={{ width: 25, height: 25 }} onChange={(e) => this.checkItem('DPL', e.target.checked)} />{' '}
                            <bs4.Label style={{ fontSize: '16px', fontWeight: 500, marginLeft: 20 }}>DPL</bs4.Label>
                        </bs4.Label>
                    </bs4.FormGroup>
                    <bs4.FormGroup check style={{ marginRight: 20 }}>
                        <bs4.Label check>
                            <bs4.Input type="checkbox" style={{ width: 25, height: 25 }} onChange={(e) => this.checkItem('DFIX', e.target.checked)} />{' '}
                            <bs4.Label style={{ fontSize: '16px', fontWeight: 500, marginLeft: 20 }}>DFIX</bs4.Label>
                        </bs4.Label>
                    </bs4.FormGroup>
                    <bs4.FormGroup check style={{ marginRight: 50 }}>
                        <bs4.Label check>
                            <bs4.Input type="checkbox" style={{ width: 25, height: 25 }} onChange={(e) => this.checkItem('DPT', e.target.checked)} />{' '}
                            <bs4.Label style={{ fontSize: '16px', fontWeight: 500, marginLeft: 20 }}>DPT</bs4.Label>
                        </bs4.Label>
                    </bs4.FormGroup>

                    <bs4.Button color="warning" style={{ marginLeft: 20, fontWeight: 500 }} onClick={() => this.addItemDB()}>ADD ITEM</bs4.Button>
                </bs4.FormGroup>
            </Modal>

            {/* <bs4.Modal isOpen={this.state.modal} toggle={this.modalDB} size='md' >
                <bs4.ModalHeader toggle={this.modalDB}>เลือกฐานข้อมูล</bs4.ModalHeader>
                <bs4.ModalBody>
                    <bs4.FormGroup row style={{ marginLeft: 20, marginTop: 20 }}>
                        <bs4.FormGroup check style={{ marginRight: 20 }}>
                            <bs4.Label check>
                                <bs4.Input type="checkbox" style={{ width: 25, height: 25 }} onChange={(e) => this.checkItem('DPL', e.target.checked)} />{' '}
                                <bs4.Label style={{ fontSize: '16px', fontWeight: 500, marginLeft: 20 }}>DPL</bs4.Label>
                            </bs4.Label>
                        </bs4.FormGroup>
                        <bs4.FormGroup check style={{ marginRight: 20 }}>
                            <bs4.Label check>
                                <bs4.Input type="checkbox" style={{ width: 25, height: 25 }} onChange={(e) => this.checkItem('DFIX', e.target.checked)} />{' '}
                                <bs4.Label style={{ fontSize: '16px', fontWeight: 500, marginLeft: 20 }}>DFIX</bs4.Label>
                            </bs4.Label>
                        </bs4.FormGroup>
                        <bs4.FormGroup check style={{ marginRight: 50 }}>
                            <bs4.Label check>
                                <bs4.Input type="checkbox" style={{ width: 25, height: 25 }} onChange={(e) => this.checkItem('DPT', e.target.checked)} />{' '}
                                <bs4.Label style={{ fontSize: '16px', fontWeight: 500, marginLeft: 20 }}>DPT</bs4.Label>
                            </bs4.Label>
                        </bs4.FormGroup>

                        <bs4.Button color="warning" style={{ marginLeft: 20, fontWeight: 500 }} onClick={() => this.addItemDB()}>ADD ITEM</bs4.Button>
                    </bs4.FormGroup>
                </bs4.ModalBody>
            </bs4.Modal> */}
        </div >
    }
}

export default Film_CreateCode